import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";

type CreateTrainingOptions = {
  silent?: boolean;
};

export const createTraning = async (postData:any, options: CreateTrainingOptions = {}) => {
  try {
    return await post<ApiResponse<[]>>(`/cleaner/training`, postData).then((res)=> {
        if(res.success === true) {
            if (!options?.silent) {
              SuccessMessage('API.SUCCESS.TRAINING.ADD')
            }
            return res
        }
        else {
            return null
        }
    })
  }
  catch(e:any) {
    HandleApiError(e);
            return null
  }
};
